import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Icon from '../../../../assets/icons/icon';
import { removeKeys } from '../../../../utilities/leadFunctions';
import { decodeJsonFix } from '../../../../utilities/jsonUtil'
import { updateLeadData } from '../../../../utilities/leadFunctions';
import { useDispatch } from 'react-redux';
import { updateSingleField } from '../../../../features/leadDataInfoSlice';

function AdditionalInfo() {
    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);
    const agentId=useSelector((state) => state.agent.userData).agentId;
    const [isOpen, setIsOpen] = useState(false);
    const [innerWrapperHeight, setInnerWrapperHeight] = useState(0);
    const [customFields, setCustomFields] = useState({});
    const [editingField, setEditingField] = useState(null);
    const inputRef = useRef(null);
    const innerWrapperRef = useRef(null);
    const keysToRemove = ["ID","Switchboard", "pushed_to_sb", "SB_Contact_ID", "Tags","PushedToOptDate", 'Status' , 'Pdf' , 'Type of Contact' , 'privateAttributes' , 'leadReferences' , 'healthQuestions' , 'consent'];
    const openUp = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        if (innerWrapperRef.current) {
            setInnerWrapperHeight(innerWrapperRef.current.clientHeight);
        }
    }, [isOpen]);

    useEffect(() => {
        if(leadsAlldata['custom_fields'] !== ' N;' || leadsAlldata['custom_fields'] !== '{}' || leadsAlldata['custom_fields'] !== 'N; ' || leadsAlldata['custom_fields']){
            const newObj=removeKeys(decodeJsonFix(leadsAlldata['custom_fields']), keysToRemove)
            setCustomFields(newObj);
        }
    }, [leadsAlldata]);
    const handleFieldChange = (key, newValue) => {
        setCustomFields(prevFields => ({
            ...prevFields,
            [key]: newValue
        }));

    };
    useEffect(() => {
        if (editingField && inputRef.current) {
          inputRef.current.focus();
        }
    }, [editingField]);

    const dispatch = useDispatch()
    const handleBlur = async (key, value) => {
        if (leadsAlldata.lead_id) {
            await updateLeadData('custom_fields', JSON.stringify(customFields), leadsAlldata.lead_id, agentId)
            dispatch(updateSingleField({id: leadsAlldata.lead_id, field: 'custom_fields', value: JSON.stringify(customFields)}))

            // handle re-mapping of custom fields to the proper lead field
            switch (key) {
                case 'Requested Coverage Amount Range':
                    await updateLeadData('coverage_amount', value, leadsAlldata.lead_id, agentId)
                    dispatch(updateSingleField({id: leadsAlldata.lead_id, field: 'coverage_amount', value}))
                    break
                case 'Requested Coverage Amount':
                    // Requested Coverage Amount Range should always take priority over this field
                    const updatedValue = !!customFields['Requested Coverage Amount Range'] ? customFields['Requested Coverage Amount Range'] : value

                    // it's possible that leadsAlldata.coverage_amount is already set to the 'Requested Coverage Amount Range' custom field
                    if(updatedValue !== leadsAlldata.coverage_amount){
                        await updateLeadData('coverage_amount', updatedValue, leadsAlldata.lead_id, agentId)
                        dispatch(updateSingleField({id: leadsAlldata.lead_id, field: 'coverage_amount', value: updatedValue}))
                    }
                    break
                default:
                    break
            }
        }
        setEditingField(null)
    }

    return (
        <div className={`quilityNestedBlockWrapper ${isOpen ? '' : ''}`} style={{overflow: "hidden"}} >
            <div className="quilityNestedBlockHeader" onClick={openUp}>
                <div className="quilityParentBlockTitle">Custom Information</div>
                <span className={`quilityBlockIcon ${!isOpen ? 'rotate':''}`} style={{marginTop: '-5px', transition:'all .5s'}}><span className="fontello"><Icon name={'q-up'} size={20} className="closeIcon" adjust="fontello" /></span></span>
            </div>
            <div className="quilityNestedBlockContent" style={{ height: isOpen ? innerWrapperHeight + 25 : '0px' }}>
                <div className="innerWrapper" ref={innerWrapperRef}>
                    {Object.entries(customFields).map(([key, value]) => (
                         (
                            <div className="leadCardBlock doubleLine" key={`additionalInfoBlock${key}`}>
                                <div key={key} className="leadInfoLine" >
                                    <div className="dataFieldTitle">{key.replace('_',' ')}</div>
                                    <span className="leadData">
                                        <input
                                            type="text"
                                            className="qualifierFieldInput"
                                            value={value}
                                            onChange={(e) => handleFieldChange(key, e.target.value)}
                                            onBlur={ e => handleBlur(key, e.target.value)}
                                            ref={inputRef}
                                            maxLength={75}
                                        />
                                    </span>
                                </div>
                            </div>
                        )
                    ))}
                </div>
            </div>
        </div>
    );
}

export default AdditionalInfo;

